export default "__VITE_ASSET__DahpGd_Z__"